import { computed } from 'mobx';
import { PartialDeep } from 'type-fest';

import { translate } from 'services/i18nService';
import { AbstractTheme, CampaignFlagsMap, ControlledFeaturesMap, Theme } from 'themes/themes.types';
import { getThemePart } from 'themes/utils';

import styles from './AugustTheme.css';


const SLOGAN_TRANSLATE_KEY = 'campaigns.easter2020.global.title';
const TOKEN_OFFER_TRANSLATE_KEY = 'campaigns.blueBalls2021.directory.text';

export default class AugustTheme extends AbstractTheme {
  static CFS: ControlledFeaturesMap = {};
  static CAMPAIGN_FLAGS: CampaignFlagsMap = {
    ON_CAM_ANIMATION: 'AUGUST_ON_CAM_ANIMATION',
    HEADER_CTA: 'AUGUST_HEADER_CTA',
    MOBILE_OVERLAY: 'AUGUST_MOBILE_OVERLAY',
  };

  @computed get theme(): PartialDeep<Theme> {
    return {
      onCamAnimation: getThemePart<'onCamAnimation'>(AugustTheme.CAMPAIGN_FLAGS.ON_CAM_ANIMATION, (campaign) => {
        return {
          cookieNamePrefix: campaign.activeCampaignName,
          animBackgroundClass: styles.animBackground,
          animBackground2Class: styles.animBackground2,
          staticBackgroundClass: styles.staticBackground,
          animTextClass: styles.animText,
          animWrapperClass: styles.animWrapper,
          line1Text: translate(TOKEN_OFFER_TRANSLATE_KEY,
            { 0: campaign.campaignDetails.bonusTokenPercent }
          ),
        };
      }),

      headerCTA: getThemePart<'headerCTA'>(AugustTheme.CAMPAIGN_FLAGS.HEADER_CTA, (campaign) => {
        return {
          cookieNamePrefix: campaign.activeCampaignName,
          wrapperClass: styles.headerCTAWrapper,
          title: translate(SLOGAN_TRANSLATE_KEY),
        };
      }),

      mobileOverlay: getThemePart<'mobileOverlay'>(AugustTheme.CAMPAIGN_FLAGS.MOBILE_OVERLAY, (campaign) => {
        return {
          cookieNamePrefix: campaign.activeCampaignName,
          title: translate(SLOGAN_TRANSLATE_KEY),
          text: translate(TOKEN_OFFER_TRANSLATE_KEY,
            { 0: campaign.campaignDetails.bonusTokenPercent }
          ),
          bodyClass: styles.mobileOverlayBody,
        };
      }),
    };
  }
}
